import React from 'react';

// Utilities
import bem from '../../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../../lib/bemUtils/Modifier';

export enum FormsElementContainerModifier {
  BUTTON_GROUP_RIGHT = 'button-group-right',
}

type FormsElementContainerProps = {
  modifier?: Modifier<FormsElementContainerModifier>;
  children: React.ReactNode;
};

/** The container for form elements. Best semantic is <p> here. */
export default function FormsElementContainer({ modifier, children }: FormsElementContainerProps) {
  return <p className={bem('form-element-container', modifier)}>{children}</p>;
}
